import React from 'react';

const NotFoundPage: React.FC = () => {
  return <div>Page not found</div>;
};

export default NotFoundPage;
